// extracted by mini-css-extract-plugin
export default {"tooltipsWrapper":"tooltips_tooltipsWrapper__nTfgX"};